/**
 * Pure SoT: when a metered job's actual credits exceed the provisional estimate
 * enough to warrant a user-facing transparency callout.
 * Not an org-budget check — see MeteredJob affordability LEARNINGS.
 */

export type EstimateOverageReasonCode =
	| "quality_retry"
	| "extra_rembg"
	| "model_repricing"
	| "unknown";

export interface ResolveEstimateOverageInput {
	estimated: number;
	actual: number;
}

export interface ResolveEstimateOverageResult {
	isOverage: boolean;
	delta: number;
	threshold: number;
}

export function resolveEstimateOverageThreshold(estimated: number): number {
	const e = Math.max(0, Math.floor(estimated));
	return Math.max(1, Math.ceil(e * 0.1));
}

export function resolveEstimateOverage(
	input: ResolveEstimateOverageInput,
): ResolveEstimateOverageResult {
	const estimated = Math.max(0, Math.floor(input.estimated));
	const actual = Math.max(0, Math.floor(input.actual));
	const delta = actual - estimated;
	const threshold = resolveEstimateOverageThreshold(estimated);
	return {
		isOverage: delta >= threshold,
		delta,
		threshold,
	};
}

export interface ResolveEstimateOverageReasonInput {
	falResubmitCount?: number | null;
	rembgApplied?: boolean | null;
	/** When true and no resubmit, prefer extra_rembg over unknown. */
	preferExtraRembg?: boolean;
}

export function resolveEstimateOverageReasonCode(
	input: ResolveEstimateOverageReasonInput,
): EstimateOverageReasonCode {
	if ((input.falResubmitCount ?? 0) > 0) {
		return "quality_retry";
	}
	if (input.rembgApplied || input.preferExtraRembg) {
		return "extra_rembg";
	}
	return "unknown";
}
